import { DefaultMenuItem } from '../../@inax/menu/src/default/defaultMenuItem';
import { IMenuItem } from '../../@inax/menu/src/interfaces/menuItem';
import { BUTTONMENU_TOKEN } from '../../@inax/menu/src/default/defaultMenuProvider';


let menu : Array<IMenuItem> = [
        new DefaultMenuItem(0,"Main","",[
            new DefaultMenuItem(0,"Home","/home")
        ]),
        new DefaultMenuItem(1,"Controller","",[
        ]),
        new DefaultMenuItem(2),
        new DefaultMenuItem(3,"Motions","",[
            new DefaultMenuItem(0,"VK","/motion/1100"),
            new DefaultMenuItem(1,"Station","/motion/1180")
        ]),
        new DefaultMenuItem(4, "Alarms","",[
            new DefaultMenuItem(0,"Pending","/alarms/pending"),
            new DefaultMenuItem(4,"History","/alarms/historical")
        ]),
        new DefaultMenuItem(5,"Diagnosis", "",[
            new DefaultMenuItem(12,"Sql","/sqlviewer")
        ]),
        new DefaultMenuItem(6),
        new DefaultMenuItem(7,"Maintenance","",[
            new DefaultMenuItem(1,"Login","/login"),
            new DefaultMenuItem(2,"INAXConfig", "/configuration"), 
            new DefaultMenuItem(3,"Test","/testpage"),
            new DefaultMenuItem(4,"Plc","/plcviewer"),
            new DefaultMenuItem(5,"Sql","/sqlviewer"),        
            new DefaultMenuItem(7,"Script","/scriptviewer")
        ]),
    ];


export const APP_MENU: any = {
  provide: BUTTONMENU_TOKEN,
  useValue: menu
};